<template>
  <div>
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// src/App.vue